import { Link } from 'react-router-dom';
import Toggle from '../../../utils/Toggle';
import { Row, Col } from '../../../utils/grid/Grid';
import HostWrapText from '../../../helper/HostWrapText';
import I18n from '../../../config/i18n';
import { getSearchPath } from '../../../routes/config';
import ReviewHeaderLine from '../../../features/accommodationReviews/components/ReviewHeaderLine';

import './HostInfo.css';
import CountryName from '../../host/CountryName';
import RatingStars from '../../host/RatingStars';
import ExtraServicesRow from '../../hostTeaser/ExtraServicesRow';
import { Accommodation } from '../../../routes/reducers/types';
import CapacityIcons from '../../host/CapacityIcons';

function HostInfoTitle({ sellingLine }: Pick<HostInfoProps, 'sellingLine'>): JSX.Element {
  return <h1 className="host-info-title">{sellingLine}</h1>;
}

function HostInfoSlug({
  locality,
  region,
  shortDisplayTitle,
  country,
}: Pick<HostInfoProps, 'country' | 'shortDisplayTitle' | 'locality' | 'region'>): JSX.Element {
  return (
    <div className="host-info-header-location">
      <span className="host-info-header-title">{shortDisplayTitle}</span>
      <span className="host-info-header-separator"> · </span>
      <span className="host-info-header-location-title">
        <HostWrapText item={locality} suffix=", " />
        <HostWrapText item={region} suffix=", " />
        <span>
          <CountryName countryCode={country} />
        </span>
      </span>
    </div>
  );
}

function HostInfoBackButton(): JSX.Element {
  return (
    <Link className="host-info-back-button" to={getSearchPath()}>
      {I18n.t('search.back_to_search_list')}
    </Link>
  );
}

interface HostInfoProps {
  accommodation: Accommodation;
  country: string;
  locality: string;
  rating: number;
  region?: string;
  sellingLine: string;
  shortDisplayTitle: string;
}

export default function HostInfo({
  accommodation,
  country,
  locality,
  rating,
  region,
  sellingLine,
  shortDisplayTitle,
}: HostInfoProps): JSX.Element {
  return (
    <div className="host-info">
      <Toggle hide="xs sm">
        <Row>
          <Col md={8} lg={9}>
            <HostInfoSlug
              country={country}
              locality={locality}
              shortDisplayTitle={shortDisplayTitle}
              region={region}
            />
            <HostInfoTitle sellingLine={sellingLine} />
            <div className="host-info__icon-row">
              <div className="host-info__capcity-icons">
                <CapacityIcons
                  maxPersons={accommodation.max_persons}
                  numberOfBaths={accommodation.number_of_baths}
                  numberOfRooms={accommodation.number_of_rooms}
                />
              </div>
              {accommodation.extra_service_conditions.length > 0 ? (
                <div className="host-info__extra-services">
                  <ExtraServicesRow
                    extraServiceConditions={accommodation.extra_service_conditions}
                  />
                </div>
              ) : null}
            </div>
            <div className="host-info__review">
              <ReviewHeaderLine linkTarget="#reviews" />
            </div>
          </Col>
          <Col md={4} lg={3}>
            <div className="host-info-rating">
              <RatingStars rating={rating} />
            </div>
            <HostInfoBackButton />
          </Col>
        </Row>
      </Toggle>
      <Toggle hide="md lg xl">
        <Row>
          <Col xs={12}>
            <div className="host-info-rating">
              <RatingStars rating={rating} />
            </div>
            <HostInfoSlug
              country={country}
              locality={locality}
              shortDisplayTitle={shortDisplayTitle}
              region={region}
            />
            <HostInfoTitle sellingLine={sellingLine} />
            <div className="host-info__icon-row">
              <div className="host-info__capcity-icons">
                <CapacityIcons
                  maxPersons={accommodation.max_persons}
                  numberOfBaths={accommodation.number_of_baths}
                  numberOfRooms={accommodation.number_of_rooms}
                />
              </div>
              {accommodation.extra_service_conditions.length > 0 ? (
                <div className="host-info__extra-services">
                  <ExtraServicesRow
                    extraServiceConditions={accommodation.extra_service_conditions}
                  />
                </div>
              ) : null}
            </div>
            <div className="host-info__review">
              <ReviewHeaderLine linkTarget="#reviews" />
            </div>
            <HostInfoBackButton />
          </Col>
        </Row>
      </Toggle>
    </div>
  );
}
